import React, { forwardRef } from "react";
import { useNavigate } from "react-router-dom";

const Business = forwardRef((props, ref)=> {
    const navigate = useNavigate();
    const handleNavigation=()=>{
        navigate('/contactus')
    }
    return (
        <>
            <div className="business-bg" ref={ref}>
                <div className="business-text">
                    <h6>Let's get started</h6>
                    <div className="sub-business">
                        <h2 style={{color:'#0e2b5c',fontWeight:'bold',marginBottom:'20px'}}>Are you ready for a better,<br/> more productive business?</h2>
                        <p>
                            Stop worrying about technology problems. Focus on your business.
                            <br />

                            Let us provide the support you deserve.
                        </p>
                        <button onClick={handleNavigation} className="con-btn">Contact Us</button>
                    </div>
                </div>
            </div>

        </>
    )
});
export default Business;